import { SelectField, TextField } from '@/components/ui'

export interface DynamicFieldConfig {
  label: string
  description?: string
  type: 'text' | 'date' | 'select'
  required?: boolean
  options?: { key: string; label: string }[]
}

interface DynamicFieldProps {
  field: DynamicFieldConfig
  value: string
  onChange: (value: string) => void
  onCommit?: (value: string) => void
}

export const DynamicField = ({
  field,
  value,
  onChange,
  onCommit,
}: DynamicFieldProps) => {
  if (field.type === 'select' && field.options) {
    return (
      <SelectField
        label={field.label}
        helpText={field.description}
        value={value}
        onValueChange={(next) => {
          onChange(next)
          onCommit?.(next)
        }}
        options={field.options.map((option) => ({
          label: option.label,
          value: option.key,
        }))}
        placeholder={`Select ${field.label.toLowerCase()}`}
      />
    )
  }

  return (
    <TextField
      label={field.label}
      helpText={field.description}
      type={field.type === 'date' ? 'date' : 'text'}
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        onChange(event.target.value)
      }
      onBlur={() => onCommit?.(value)}
      required={field.required}
    />
  )
}
